// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// Layouts
import AuthLayout from '@/layouts/AuthLayout.vue'

// Feature Routes
import authRoutes from '@/features/auth/routes'
import counterRoutes from '@/features/counter/routes'
import FacturacionRoutes from '@/features/billing/routes'
import companyRoutes from '@/features/company/routes'
import categoryRoutes from '@/features/category/routes'
import plantsRoutes from '@/features/plants/routes'
import ownersRoutes from '@/features/owners/routes'
import userRoutes from '@/features/user/routes'
import dashboardRoutes from '@/features/dashboard/routes'
import certificationRoutes from '@/features/certification/routes'
import operationRoutes from '@/features/operation/routes'
import investmentRoutes from '@/features/investment/routes'
import certificadosRoutes from '@/features/certificados/route'
import ipsRoutes from '@/features/ips/routes'
import contactCenterRoutes from '@/features/contacCenter/route'
import connectVtsRoutes from '@/features/connect-vts/routes'
// Guards
import { authGuard } from './guards/auth'
import { blockLoadingGuard } from './guards/blockLoading'

const routes = [
  {
    path: '/auth',
    component: AuthLayout,
    children: authRoutes, 
  },

  {
    path: '/app',
    component: () => import('@/layouts/PrivateLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      ...dashboardRoutes,
      ...operationRoutes,
      ...counterRoutes,
      ...certificationRoutes,
      ...investmentRoutes,
      ...FacturacionRoutes,
      ...companyRoutes,
      ...categoryRoutes,
      ...plantsRoutes,
      ...ownersRoutes,
      ...userRoutes,
      ...certificadosRoutes,
      ...ipsRoutes,
      ...contactCenterRoutes,
      ...connectVtsRoutes,
      {
        path: '',
        redirect: '/app/dashboard',
      },
    ],
  },

  {
    path: '/',
    redirect: '/auth/login', 
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/auth/login',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// Primero bloquear la navegación si hay una petición crítica en curso
router.beforeEach(blockLoadingGuard)
router.beforeEach(authGuard)

export default router
